const isEmail = (email: string) =>
    /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);

export const validateEmail = (email: string) => {
    if (!isEmail(email)) return false

    return true;
};